import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { VendorIntegrationService } from '@app/@shared/services/vendor-integration.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EmbeddedURLModel } from '@shared/models/embedded-url.model';
import { EmbeddedURLRequestModel } from '@shared/models/embedded-url-request.model';
import { environment } from '@env/environment';

@Component({
    selector: 'app-retool-iframe',
    templateUrl: './retool-iframe.component.html',
    styleUrls: ['./retool-iframe.component.scss'],
    standalone: false
})
@UntilDestroy()
export class RetoolIframeComponent implements OnInit {
  @Input() set embeddedURLRequest(embeddedURLRequest: EmbeddedURLRequestModel) {
    this._embeddedURL = embeddedURLRequest;
    this.loadEmbeddedUrl(this._embeddedURL);
  }
  get embeddedURLRequest(): EmbeddedURLRequestModel {
    return this._embeddedURL
  }
  public embeddedUrl: SafeResourceUrl;
  public loading = true;
  private _embeddedURL: EmbeddedURLRequestModel;

  constructor(
    private route: ActivatedRoute,
    protected vendorIntegrationService: VendorIntegrationService,
    private readonly sanitizer: DomSanitizer
  ) {
  }

  public ngOnInit(): void {
    if(!this.embeddedURLRequest) {
      this.embeddedURLRequest = {
        appId: this.route.snapshot.params?.appId,
      }
    }

    this.loadEmbeddedUrl(this.embeddedURLRequest);
  }

  private loadEmbeddedUrl(embeddedURLRequestModel: EmbeddedURLRequestModel) {
    this.loading = true;
    this.vendorIntegrationService
      .getEmbeddedURL(embeddedURLRequestModel)
      .pipe(
        catchError(_err => {
          this.loading = false;
          return of({ 'embedUrl': '' });
        }),
        untilDestroyed(this)
      ).subscribe((embeddedUrl: EmbeddedURLModel) => {
      this.loading = false;

      this.embeddedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.getSafeUrl(embeddedUrl.embedUrl));
    });
  }

  private getSafeUrl(url: string): string {
    if (url.startsWith(environment.retoolUrl)) {
      return url;
    }

    return '';
  }
}
